// i18n area 'cluster' — locale pl-PL (task #171, onda 3): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/cluster.pl-PL.meta.json.
import type { enUS } from './cluster'

export const plPL: typeof enUS = {
  cluster: {
    // #233 — gli accessi di garanzia di un nodo (tradotto dall'italiano)
    nodeAccess: {
      title: 'Dostępy gwarancyjne',
      subtitle: 'Drzwi serwisowe węzła: dostęp tylko do odczytu z tymczasowym hasłem oraz konto awaryjne z hasłem z sejfu',
      readOnlyTitle: 'Dostęp tylko do odczytu (trantor)',
      stateNone: 'zamknięty',
      stateGranted: 'otwarty',
      stateGrantedPending: 'przyznany — wdrażany na węźle',
      grantedBy: 'Przyznał',
      grantedAt: 'Przyznano',
      expiresAt: 'Wygasa',
      reason: 'Powód',
      endedAt: 'Zamknięty',
      endedReason: {
        revoked: 'cofnięty',
        expired: 'wygasł (TTL)',
        reboot: 'restart węzła',
        failed: 'niewdrożony (zadanie nie powiodło się)'
      },
      grant: 'Przyznaj dostęp tylko do odczytu…',
      grantTitle: 'Przyznaj dostęp tylko do odczytu',
      grantSubmit: 'Przyznaj',
      grantError: 'Przyznanie zostało odrzucone',
      grantConfirm: 'TVirt generuje tymczasowe hasło dla użytkownika systemowego «trantor» (tylko odczyt: journal i diagnostyka, bez sudo) i ustawia je na węźle za pomocą zadania. Hasło jest pokazywane TYLKO raz, przy potwierdzeniu; wygasa z upływem terminu, po cofnięciu lub przy następnym restarcie węzła.',
      reasonLabel: 'Powód',
      reasonHint: 'Dlaczego otwierasz drzwi: trafia do przyznania, audytu i dziennika',
      ttlLabel: 'Czas trwania',
      ttlHours: '{n} h',
      revoke: 'Cofnij dostęp tylko do odczytu…',
      revokeTitle: 'Cofnij dostęp tylko do odczytu',
      revokeSubmit: 'Cofnij',
      revokeError: 'Cofnięcie zostało odrzucone',
      revokeConfirm: 'Przyznanie kończy się natychmiast, a zadanie ponownie blokuje użytkownika «trantor» na węźle: tymczasowe hasło przestaje działać.',
      passwordTitle: 'Hasło tylko do odczytu',
      passwordOnce: 'To hasło jest pokazywane TYLKO raz: skopiuj je teraz. Nie jest nigdzie zapisywane i nie będzie można go odczytać ponownie — jeśli je zgubisz, przyznaj ponownie.',
      passwordUser: 'Użytkownik',
      passwordLabel: 'Hasło',
      passwordHint: 'Ważne do {until} lub do następnego restartu węzła; użyteczne, gdy zadanie przyznania zostanie ukończone. Dostęp: ssh trantor@<adres węzła>.',
      emergencyTitle: 'Ostatni dostęp awaryjny (trantor-emergency)',
      lastLogin: '{time} przez {via} z {from}',
      lastLoginNone: 'nie zaobserwowano',
      lastLoginVia: {
        ssh: 'ssh',
        console: 'konsola',
        sudo: 'sudo',
        unknown: 'nieznany'
      },
      emergencyHint: 'Konto awaryjne «trantor-emergency» (pełne sudo) jest zawsze włączone z hasłem wygenerowanym przy instalacji węzła i przechowywanym w sejfie: TVirt go nie zna, nie rotuje i nie odzyskuje. Każde logowanie jest raportowane tutaj i w dzienniku zdarzeń.'
    },
    nodeFirewall: {
      tab: 'Firewall',
      title: 'Firewall węzłów',
      subtitle: 'Postura rulesetu nftables, który każdy węzeł stosuje sam do siebie — jedyny firewall węzła (firewalld jest wyłączony)',
      modeLabel: 'Postura',
      mode: {
        disabled: 'Wyłączony — żadnego rulesetu na węzłach',
        permissive: 'Permisywny — liczy i loguje, niczego nie odrzuca',
        enforced: 'Wymuszony — wchodzi tylko rejestr wyprowadzony'
      },
      hint: {
        disabled: 'Tak jak dziś: węzły nie niosą żadnego rulesetu. Przełącz na permisywny, aby ODCZYTAĆ, co zostałoby odrzucone, zanim zostanie odrzucone.',
        permissive: 'Każdy węzeł stosuje swój wyprowadzony ruleset z policy accept: to, co tryb wymuszony by odrzucił, jest liczone i logowane (prefiks w journalu «tvirt-node would-drop:»). Nic nie jest blokowane.',
        enforced: 'Każdy węzeł stosuje swój wyprowadzony ruleset z policy drop: ssh i API zewsząd, store / live migration / overlay / Ceph tylko od członków, listenery usług sieciowych z obsługiwanej sieci. Każda zmiana to apply z potwierdzeniem — węzeł, któremu nie uda się potwierdzić, sam się wycofuje.'
      },
      confirmTitle: 'Wymusić firewall węzłów?',
      confirmBody: 'Każdy węzeł stosuje ruleset z potwierdzeniem: przez nowe reguły sonduje backend, store i ssh przed upływem terminu i potwierdza — w przeciwnym razie sam wraca do poprzedniego rulesetu. Najpierw odczytaj liczniki trybu permisywnego na węzłach.',
      confirmSubmit: 'Wymuś',
      confirmCancel: 'Anuluj',
      lensTitle: 'Firewall węzła',
      loadError: 'Nie można wczytać soczewki firewalla węzła',
      noReport: 'Jeszcze żadnego raportu firewalla z tego węzła — worker zaraportuje przy następnym przebiegu',
      firewalldActive: 'Na tym węźle działa firewalld: firewall węzła odmawia zastosowania się obok niego (zamaskuj firewalld)',
      conditionUnconfirmed: 'Jeszcze żadnego potwierdzonego rulesetu — węzeł jest otwarty',
      conditionRolledBack: 'Ostatni apply został wycofany — ta sama generacja nie jest ponawiana, dopóki rejestr się nie zmieni albo postura nie zostanie zmieniona ponownie',
      lastError: 'Ostatni błąd',
      posture: 'Postura',
      observedAt: 'Zaobserwowano',
      desiredGeneration: 'Pożądana generacja',
      componentTitle: 'Komponent węzła',
      componentSubtitle: 'tvirt-node-firewall — przy starcie stosuje potwierdzony ruleset, niepotwierdzony sam wycofuje',
      componentAbsent: 'Komponent jeszcze nie zaraportował',
      phase: 'Faza',
      phases: {
        none: 'Nigdy nie zastosowano',
        applied: 'Zastosowany — oczekuje na potwierdzenie',
        confirmed: 'Potwierdzony',
        rolledBack: 'Wycofany'
      },
      generation: 'Generacja',
      appliedAt: 'Zastosowano',
      confirmedAt: 'Potwierdzono',
      deadline: 'Termin rollbacku',
      lastRollback: 'Ostatni rollback',
      registryTitle: 'Rejestr wyprowadzony',
      registrySubtitle: 'Porty, które ten węzeł otwiera, według klasy i pochodzenia — wyprowadzone z klastra, nigdy nie edytowane ręcznie',
      registryEmpty: 'Nic nie wyprowadzono — postura wyłączona bez potwierdzonego rulesetu albo jeszcze brak raportu',
      colClass: 'Klasa',
      colPort: 'Port',
      colSource: 'Źródło',
      colOrigin: 'Pochodzenie',
      classes: {
        public: 'Publiczna',
        internode: 'Międzywęzłowa',
        tenant: 'Tenant'
      },
      sourceMembers: 'tylko członkowie',
      sourceAnywhere: 'zewsząd',
      sourceBridge: 'na {iface}'
    },
    derivationDerived: 'wyprowadzony',
    derivationDiverged: 'rozbieżny',
    derivationDerivedTip: 'Dokument sieciowy jest WYPROWADZONY z fabric {fabric} i wciąż zgadza się z renderem na bieżących wejściach — kliknij po plan derywacji.',
    derivationDivergedTip: 'Derywacja z fabric {fabric} zmieniła się po ostatnim apply (fabric, okablowanie, role lub referencje) — kliknij po oczekujący diff.',
    derivationRetiring: {
      one: '{n} adres w opróżnianiu',
      few: '{n} adresy w opróżnianiu',
      many: '{n} adresów w opróżnianiu',
      other: '{n} adresu w opróżnianiu'
    },
    standaloneHint: 'Ten węzeł nie ma klastra: nie został jeszcze zainstalowany. Klaster tworzy się ALBO dołącza do niego podczas instalacji — token wygenerowany w tabeli Serwery jednego z członków podaje się instalatorowi (dev: db:init-cluster / db:init-join).',
    reducedHint: 'Twoje uprawnienia obejmują scope, nie cały klaster: inwentarz floty — węzły, ustawienia i urządzenia — widzą tylko administratorzy klastra.',
    phaseReady: 'Gotowy',
    phaseForming: 'W trakcie formowania',
    storeMembers: 'Członkowie store',
    watermark: 'Próg zbieżności',
    configGeneration: 'Generacja konfiguracji',
    converged: 'zgodny',
    behind: 'w tyle — {m} / {n}',
    revision: 'Rewizja',
    rolesTitle: 'Role sieciowe',
    rolesSubtitle: 'Adresy każdego członka dla poszczególnych klas ruchu — łączność żyje w sieci hosta',
    roleManagement: 'Management',
    roleLiveMigration: 'Live Migration',
    roleInherited: 'dziedziczy management',
    settingsTitle: 'Ustawienia',
    settingsSubtitle: 'Polityka bezpieczeństwa na poziomie klastra — każdy węzeł ocenia ją na podstawie własnej lokalnej repliki',
    taskRetentionTitle: 'Retencja tasków',
    taskRetentionSubtitle: 'Ujednolicony GC dla wszystkich tasków — zakończone taski starsze niż zadany wiek albo ponad limit są sprzątane, nigdy te w toku',
    taskRetentionMaxAge: 'Maksymalny wiek (dni)',
    taskRetentionMaxCount: 'Maksymalna liczba tasków',
    eventRetentionTitle: 'Retencja zdarzeń',
    eventRetentionSubtitle: 'GC dziennika — polityka niezależna od zadań: zadanie to kolejka, zdarzenie to pamięć',
    eventRetentionMaxAge: 'Maksymalny wiek (dni)',
    eventRetentionMaxCount: 'Maksymalna liczba zdarzeń',
    spaceThresholdsTitle: 'Progi miejsca',
    spaceThresholdsSubtitle: 'Kiedy zapełniający się magazyn trafia do dziennika (i powiadomień)',
    spaceLowPct: 'Ostrzeżenie od (% użyte)',
    spaceCriticalPct: 'Krytyczne od (% użyte)',
    spaceOrderError: 'Krytyczne nie może być poniżej ostrzeżenia',
    spaceThresholdsHint: 'Konfiguruje się tylko wejścia: wyjście wyprowadza silnik, 5 punktów poniżej każdego progu, aby magazyn stojący na linii nigdy nie stał się metronomem',
    failoverReserveTitle: 'Rezerwa failover',
    failoverReserveSubtitle: 'Admission control N+1 — RAM utrzymywana jako wolna, aby klaster mógł ponownie uruchomić własne obciążenie po utracie węzłów',
    failoverReserveTolerate: 'Liczba węzłów, których utratę należy tolerować',
    failoverReserveOff: '0 — rezerwa wyłączona: żadne uruchomienie nie jest odrzucane z powodu pojemności failover',
    failoverReserveOn: 'Uruchomienie, które naruszyłoby rezerwę, jest odrzucane błędem 412 objaśniającym liczby',
    networkShapingTitle: 'Sprawiedliwość pasma',
    networkShapingSubtitle: 'Trzy wagi typologii drzewa shapingu na uplink — działają tylko przy rywalizacji o pasmo',
    networkShapingRest: 'Waga reszty (płaszczyzna sterowania, storage, repliki)',
    networkShapingOverlay: 'Waga sieci overlay',
    networkShapingLiveMigration: 'Waga live migration',
    networkShapingHint: 'Gwarantowany udział = waga / suma trzech (domyślnie 300 / 100 / 200, każda od 1 do 10000); na wolnym łączu każda klasa może zająć całe pasmo',
    debugModeTitle: 'Tryb debug',
    debugModeSubtitle:
      'Szczegółowe błędy w ogólnych powiadomieniach GUI — żeby zobaczyć prawdziwą przyczynę, gdy działanie „zakończone niepowodzeniem” w rzeczywistości się powiodło',
    debugModeLabel: 'Tryb debug włączony',
    debugModeOn: 'Ogólne powiadomienia o błędach dołączają przyczynę źródłową — szczegóły wewnętrzne widoczne dla każdego operatora',
    debugModeOffHint: 'Wyłączony — ogólne powiadomienia o błędach pozostają ogólne, bez szczegółów wewnętrznych',
    nodeDetailsAction: 'Szczegóły węzła',
    node: {
      docTitle: 'Węzeł',
      notFound: 'Nie znaleziono węzła',
      tabOverview: 'Przegląd',
      tabStats: 'Statystyki',
      tabNetwork: 'Sieć',
      tabSettings: 'Ustawienia lokalne',
      identityTitle: 'Tożsamość',
      heartbeatTitle: 'Heartbeat',
      ysqlPort: 'Port YSQL',
      revision: 'Rewizja konfiguracji',
      versionsTitle: 'Obserwowane wersje',
      heartbeatSubtitle: 'Ostatni stan, jaki węzeł zaraportował o sobie samym',
      cpuTitle: 'CPU',
      cpuModelTitle: 'Model CPU',
      memoryTitle: 'Pamięć',
      hugePagesTitle: 'Ogromne strony',
      hugePagesPool: '{size}: {free} wolnych z {total}',
      hugePagesNone: 'Brak puli',
      hugePagesNoneHint: 'Węzeł nie ma zarezerwowanych ogromnych stron: VM, które ich żądają, nie mogą się tu uruchomić. Pulę deklaruje się na węźle, parametrami kernela hugepagesz i hugepages albo wpisując nr_hugepages.',
      usageTitle: 'Bieżące użycie',
      usageMem: 'RAM {n} MiB',
      usageUnknown: 'nieobserwowane — brak świeżej próbki',
      statsNoData: 'Brak danych w tym przedziale — serie węzła są próbkowane przez sam węzeł i serwowane lokalnie.',
      observedTitle: 'Stan obserwowany',
      observedSubtitle: 'Usługi i zasoby lokalne węzła, tak jak widzi je worker'
    },
    editRolesTitle: 'Edytuj role sieciowe',
    memberNode: 'Węzeł',
    memberIp: 'Adres IP',
    addMember: 'Dodaj członka',
    lmInherit: 'Użyj adresów management',
    roleIpHint: 'Dodawanie i usuwanie członków jest dowolne; zmiana adresu IP istniejącego członka w miejscu jest odrzucana — przepływ migracji IP pojawi się w kolejnej rundzie.',
    roleError: 'Nie można zaktualizować ról',
    nodesTitle: 'Węzły',
    addNodeTitle: 'Dodaj węzeł do klastra',
    addNode: 'Dodaj węzeł',
    addNodeError: 'Nie można wstępnie zarejestrować węzła',
    nodeName: 'Nazwa węzła',
    nodeNameHint: 'musi się zgadzać z nazwą wybraną podczas instalacji',
    nodeIp: 'IP management',
    colName: 'Nazwa',
    colPhase: 'Faza',
    colServices: 'Usługi',
    colWatermark: 'Watermark',
    colLastSeen: 'Ostatni kontakt',
    colUps: 'UPS',
    upsCordonChip: 'kordon UPS',
    upsCordonTip: 'Węzeł skazał sam siebie na podstawie faktów swojego UPS ({time}): sam zdejmie kordon, gdy sieć będzie stabilna, a akumulator naładowany',
    upsUnreachable: 'UPS nieosiągalny',
    upsOnBattery: 'Na akumulatorze',
    upsOnLine: 'Na sieci',
    upsLowBattery: 'niski poziom akumulatora',
    upsNoEstimateChip: 'czas pracy nieoszacowany',
    upsNoEstimateTip: 'UPS nie publikuje szacunku pozostałego czasu: węzeł jest skazywany wyłącznie przez flagę LB (niski akumulator) UPS — dostrój battery.runtime.low / LB na samym UPS',
    upsLaneTip: 'Ścieżka wyłączania UPS od {since}: skazany przez {by}',
    upsUnit: 'jednostka',
    upsStatus: 'stan NUT',
    upsLoad: 'obciążenie',
    upsOnBatterySince: 'na akumulatorze od',
    upsOnLineSince: 'na sieci od',
    upsError: 'błąd',
    upsObservedAt: 'zaobserwowano',
    upsNone: 'żadna jednostka UPS nie obsługuje tego węzła',
    upsBy: {
      runtime: 'czas pracy poniżej progu',
      lowBattery: 'flaga LB UPS',
    },
    upsLane: {
      evacuate: 'ewakuacja',
      local: 'wyłączenie na miejscu',
    },
    upsPhase: {
      draining: 'drain',
      stoppingGuests: 'zatrzymywanie gości',
      stoppingServices: 'zatrzymywanie usług',
      poweredOff: 'wyłączony',
    },
    upsTitle: 'UPS (NUT)',
    upsSubtitle: 'Jednostki UPS i progi: węzeł skazany przy czasie pracy ≤ próg lub fladze LB (zawsze honorowanej), wznowienie z histerezą',
    upsRuntimeThreshold: 'Próg czasu pracy (s)',
    upsRuntimeThresholdHint: 'Na akumulatorze, przy szacowanym czasie pracy ≤ próg węzeł wyłącza się w kolejności (domyślnie 300)',
    upsResumeStable: 'Sieć stabilna przez (s)',
    upsResumeStableHint: 'Wznowienie tylko przy ciągłej sieci od co najmniej tylu sekund (domyślnie 60)',
    upsResumeCharge: 'Minimalne naładowanie przy wznowieniu (%)',
    upsResumeChargeHint: 'I akumulator naładowany co najmniej do tego procentu (domyślnie 25)',
    upsPolicyNote: 'Flaga LB (niski akumulator) UPS zawsze skazuje i nie da się jej wyłączyć; nie ma progu na czas spędzony na akumulatorze. Każda jednostka może nadpisać te trzy liczby.',
    upsUnitNew: 'nowa jednostka',
    upsUnitSelectors: '{n} selektor(y) tagów (tylko CLI)',
    upsUnitName: 'Nazwa jednostki',
    upsUnitMode: 'Tryb',
    upsModeExternal: 'zewnętrzna (cudzy upsd)',
    upsModeManaged: 'zarządzana (UPS podłączony do węzła)',
    upsUnitUpsname: 'Nazwa NUT (upsname)',
    upsUnitHost: 'Host upsd',
    upsUnitAttachedNode: 'Podłączony węzeł',
    upsUnitDriver: 'Sterownik NUT',
    upsUnitDriverHint: 'usbhid-ups, nutdrv_qx, snmp-ups, …',
    upsUnitDevice: 'Urządzenie sterownika',
    upsUnitDeviceHint: 'linia port= w ups.conf: puste = auto',
    upsUnitPort: 'Port upsd',
    upsUnitServedNodes: 'Obsługiwane węzły',
    upsUnitServedNodesHint: 'nazwy węzłów oddzielone przecinkami (selektory tagów przez CLI)',
    upsUnitOverrideHint: 'puste = domyślne klastra',
    upsUnitAdd: 'Dodaj jednostkę',
    unreachableSince: 'Nieosiągalny — ostatni heartbeat {time}',
    overlaysChip: 'overlay',
    overlaysBehind: 'Dataplane overlay nie zrealizował jeszcze bieżącej konfiguracji overlay',
    overlaysError: 'Ostatni przebieg uzgadniania overlay nie powiódł się: {error}',
    storeChip: 'store',
    phase: {
      'pending-join': 'Oczekuje na dołączenie',
      'joining': 'Dołącza',
      'member': 'Członek'
    },
    tokenTitle: 'Token dołączenia',
    tokenOnce: 'Pokazany tylko teraz — należy go od razu skopiować, później nie da się go odczytać',
    copy: 'Kopiuj',
    copied: 'Skopiowano',
    close: 'Zamknij',
    revokeTitle: 'Unieważnij wstępną rejestrację',
    revoke: 'Unieważnij',
    revokeError: 'Nie można unieważnić rejestracji',
    promote: 'Awansuj na członka store',
    demote: 'Odbierz rolę członka store',
    troubleshoot: 'Rozwiązywanie problemów',
    promoteTitle: 'Awansuj na członka store',
    demoteTitle: 'Odbierz rolę członka store',
    promoteHint: 'Węzeł wchodzi do kworum masterów YugabyteDB. Prawdziwe HA wymaga trzech członków store.',
    demoteHint: 'Węzeł wychodzi z kworum masterów i zatrzymuje swoje usługi store.',
    storeError: 'Zmiana roli członka store została odrzucona',
    attest: 'Potwierdź wyłączenie…',
    attestTitle: 'Potwierdź, że węzeł jest wyłączony',
    attestSubmit: 'Potwierdź wyłączenie',
    attestConfirm: 'Ten węzeł zostaje uznany za wyłączony, na własne ryzyko operatora: potwierdzenie węzła, który w rzeczywistości żyje, grozi podwójnym uruchomieniem VM. Jego taski kończą się błędem, a authority jego VM staje się przenoszalne.',
    attestError: 'Potwierdzenie zostało odrzucone',
    attestedChip: 'potwierdzony jako wyłączony',
    maintenanceChip: 'konserwacja',
    guestToolsChip: 'TVirt Guest Tools (zasób ISO lokalny dla węzła)',
    maintenanceEnter: 'Włącz konserwację',
    maintenanceExit: 'Wyłącz konserwację',
    maintenanceEnterTitle: 'Włącz konserwację',
    maintenanceExitTitle: 'Wyłącz konserwację',
    maintenanceEnterSubmit: 'Włącz konserwację',
    maintenanceExitSubmit: 'Wyłącz konserwację',
    maintenanceEnterConfirm: 'Węzeł zostaje odgrodzony i opróżniony: usługi sieciowe i instancje App, których authority posiada, są przenoszone (instancje na zimno: zatrzymane i zżęte tutaj, odtworzone na węźle docelowym — przestój), uruchomione VM są migrowane na żywo, gdzie to możliwe, a w przeciwnym razie zatrzymywane łagodnie, trwające zadania kończą się, nowa praca czeka, a zatrzymane VM tracą swoje authority — Proximity rozmieszcza je ponownie przy następnym uruchomieniu. Po zakończeniu konserwacji nic nie wraca samo.',
    maintenanceExitConfirm: 'Węzeł wraca do pracy, a Proximity znów bierze go pod uwagę przy rozmieszczaniu. VM wracają dopiero wtedy, gdy zostaną uruchomione.',
    maintenanceError: 'Żądanie konserwacji zostało odrzucone',
    maintenancePlanTitle: 'Plan ewakuacji',
    maintenancePlanLoading: 'Obliczanie planu ewakuacji…',
    maintenancePlanError: 'Nie można wczytać planu ewakuacji — opróżnianie i tak zmigruje, co się da, a resztę zatrzyma.',
    maintenancePlanEmpty: 'Nie ma czego ewakuować z tego węzła — brak aktywnej usługi sieciowej, brak instancji App żądanej w działaniu, brak uruchomionej VM.',
    maintenancePlanSummary: '{migrate} obiektów zostanie zmigrowanych (VM, usługi sieciowe, instancje App), {stop} zatrzyma się lub pozostanie na miejscu.',
    maintenancePlanReserve_ok: 'Rezerwa failover po opróżnieniu: nienaruszona — pozostaje {headroom} GiB możliwych do uruchomienia przy tolerancji utraty węzłów: {n}.',
    maintenancePlanReserve_eroded: 'Rezerwa failover po opróżnieniu: prawie wyczerpana — pozostaje tylko {headroom} GiB z {reserve} GiB utrzymywanych jako wolne na wypadek awarii węzłów: {n}.',
    maintenancePlanReserve_exhausted: 'Rezerwa failover po opróżnieniu: WYCZERPANA — brakuje {headroom} GiB z {reserve} GiB potrzebnych, aby tolerować awarie węzłów: {n}. Dopóki ten węzeł jest wyłączony z gry, nowe uruchomienia VM będą odrzucane.',
    maintenancePlanReserve_unknown: 'Rezerwa failover po opróżnieniu: nie do obliczenia — żaden z pozostałych węzłów nie zadeklarował pamięci.',
    maintenancePlanReserveHugePages: 'Ogromne strony {size} po opróżnieniu — wolne: {free} z {capacity}, wymagane jako rezerwa: {reserve}.',
    maintenancePlanActionMigrate: 'migracja',
    maintenancePlanActionMigrateWarning: 'migracja (naruszona reguła soft)',
    maintenancePlanActionStop: 'zatrzymanie',
    maintenancePlanActionBlocked: 'zablokowana',
    maintenancePlanKindVm: 'VM',
    maintenancePlanKindNetsvc: 'usługa sieciowa',
    maintenancePlanKindApp: 'instancja App',
    maintenancePlanColdMove: 'Przeniesienie na zimno: pod jest tutaj zatrzymywany i zżynany, a worker węzła docelowego odtwarza go — przestój do następnego passu workera docelowego.',
    caFingerprint: 'Fingerprint CA klastra',
    staleChip: 'nieaktualny',
    troubleshootTitle: 'Rozwiązywanie problemów ze store',
    restartStore: 'Zrestartuj usługi store',
    restartHint: 'Jeśli store zaczyna kaprysić, należy zrestartować jego usługi. Zaawansowane — używać ostrożnie.',
    restartQueued: 'Task restartu w kolejce',
    restartError: 'Nie można zrestartować usług',
    svcActive: 'aktywna',
    svcWanted: 'wymagana, nieaktywna',
    svcStopped: 'zatrzymana',
    noServices: 'Nie zgłoszono żadnej usługi'
  },
  clusterDevices: {
    gpusTitle: 'GPU / PCIe',
    gpusSubtitle: 'Inwentarz GPU całego klastra pogrupowany według modelu — karty obserwowane na poszczególnych węzłach wraz z oznaczonymi rejestracjami i ich tagami',
    usbTitle: 'Zasoby USB',
    usbSubtitle: 'Inwentarz USB całego klastra pogrupowany według modelu — urządzenia obserwowane na poszczególnych węzłach wraz z rejestracjami w obu modelach (per urządzenie, per port) i ich tagami',
    markedChip: 'użyteczne dla TVirt: {n}',
    orphanChipGpu: 'osierocone: {n}',
    orphanChipUsb: 'osierocone: {n}',
    colNode: 'Węzeł',
    colRegistration: 'Rejestracja',
    noRegsHint: 'Brak rejestracji — urządzenie oznacza się jako "użyteczne dla TVirt" w dialogu węzła (Węzły › węzeł › Ustawienia).',
    colDevice: 'Urządzenie',
    colObserved: 'Obserwowane',
    colRegs: 'Rejestracje',
    regsNone: 'brak',
    colPci: 'Adres PCIe',
    colIdentity: 'Tożsamość / port',
    colClasses: 'Klasy (tagi)',
    colActions: 'Akcje',
    manageOnNode: 'Zarządzaj na węźle {node} (oznaczanie odbywa się w dialogu węzła)',
    introTitle: 'Inwentarz urządzeń USB i PCIe klastra użytecznych dla TVirt©.',
    introStep1: '1. Węzły same wykrywają swoje GPU i urządzenia USB (spis w heartbeacie).',
    introStep2: '2. Urządzenie oznacza się jako "użyteczne dla TVirt" w dialogu WĘZŁA (Węzły › węzeł › Ustawienia) — oznaczenie wiąże je z vfio i rejestruje tutaj.',
    introStep3: '3. Tutaj nadaje się rejestracjom ich KLASY za pomocą tagów (np. gpu_class=compute): wymagania VM poproszą o klasę, a scheduler wybierze węzeł z wolnym, zgodnym urządzeniem.',
    colMode: 'Tryb',
    colState: 'Stan',
    colNotes: 'Notatki',
    colTags: 'Tagi',
    modeDevice: 'per urządzenie',
    modePort: 'per port',
    usable: 'użyteczne',
    orphanGpu: 'osierocona',
    orphanUsb: 'osierocone',
    hubChip: 'hub',
    orphanPortsTitle: 'Rejestracje per port bez podłączonego urządzenia — należy podłączyć urządzenie ponownie albo zdjąć oznaczenie na węźle',
    gpusEmpty: 'Nie zaobserwowano jeszcze żadnej GPU na żadnym węźle',
    usbEmpty: 'Nie zaobserwowano jeszcze żadnego urządzenia USB na żadnym węźle'
  },

  // Wspólne słownictwo formularzy ustawień (refaktoryzacja 2026-07-24): pola
  // bezpieczeństwa zasilają kartę strony Klaster, pola węzła stronę
  // node-settings — strona /system/settings, dla której powstały, nie żyje.
  settings: {
    passwordMinLength: 'Minimalna długość hasła',
    sessionIdle: 'Limit bezczynności sesji (minuty)',
    lockoutThreshold: 'Blokada po nieudanych próbach',
    lockoutDuration: 'Czas trwania blokady (minuty)',
    keyboardLayout: 'Układ klawiatury',
    keyboardLayoutHint: 'np. pl, en-us — puste oznacza domyślny układ QEMU',
    syslogEndpoint: 'Endpoint syslog',
    syslogEndpointHint: 'host:port — puste wyłącza przekazywanie',
    syslogTls: 'TLS',
    maxQueued: 'Maksymalna liczba tasków w kolejce',
    concurrency: 'Współbieżność workera',
    concurrencyHint: 'Stosowana przez workera w locie',
    notesTitle: 'Notatki',
    save: 'Zapisz',
    saved: 'Ustawienia zapisane',
    saveError: 'Nie można zapisać ustawień'
  },
  localSettings: {
    derivedChip: 'wyprowadzony',
    derivedTip: 'To device NALEŻY do derywacji fabric (H2): edytor odmawia jego dotknięcia — zmień fabric (lub okablowanie) i zastosuj ponownie, albo odbierz je poniżej.',
    takeOwnership: 'Przejmij własność',
    takeOwnershipTitle: 'Przejmij własność (take-ownership)',
    takeOwnershipConfirm: '{name} opuszcza blok fabric i znów staje się RĘCZNYM device\'em rządzonym przez ten edytor. Węzeł staje się rozbieżny, a następny apply derywacji odmówi na nim (manualConflict), dopóki go nie przemianujesz lub nie usuniesz — albo nie poprawisz fabric.',
    nodeSettingsTitle: 'Ustawienia węzła',
    nodeSettingsSubtitle: 'To, co stosuje ten węzeł — kolejka tasków, konsola, przekazywanie logów — a do tego jego tagi i notatki',
    baseTitle: 'Rezerwy hosta (TVirt Proximity)',
    baseSubtitle: 'CPU i RAM zarezerwowane dla systemu operacyjnego hosta — dane wejściowe pojemności empirycznej, na podstawie której Proximity rozmieszcza VM',
    baseMemory: 'Bazowa RAM (MiB)',
    baseMemoryHint: 'Zaobserwowana całość: {total} MiB. Do użytku VM = całość − baza − RAM uruchomionych VM rozmieszczonych tutaj.',
    baseMemoryHintNoTotal: 'Do użytku VM = zaobserwowana całość − baza − RAM uruchomionych VM rozmieszczonych tutaj.',
    baseCpu: 'Bazowe rdzenie CPU',
    baseCpuHint: 'Zaobserwowane logiczne CPU: {total}. Używane wyłącznie jako waga w rankingu — overcommit vCPU jest normalny.',
    baseCpuHintNoTotal: 'Używane wyłącznie jako waga w rankingu — overcommit vCPU jest normalny.',
    baseHint: 'RAM jest twardą bramką przyjęcia: VM, która nie mieści się w dostępnej RAM, zostaje odrzucona mówiącym błędem. Na hostach z członkami store albo demonami Ceph należy podnieść bazę.',
    placementTitle: 'Rozmieszczenie fizyczne',
    placementSubtitle: 'Gdzie fizycznie stoi ten serwer — deklarowane raz, na wszelkie potrzeby',
    placementHint: 'Rozmieszczenie steruje hierarchią CRUSH każdego klastra Ceph mającego OSD na tym serwerze: zapisanie zmiany wyrównuje ich mapy poprzez task (host → rack → … → root). Deklaracje częściowe są dozwolone — puste poziomy się zwijają. Nazwy są wspólne dla całej mapy: dwa serwery w tym samym racku deklarują tę samą nazwę racka.',
    placementNameInvalid: 'Nazwa bezpieczna dla DNS (małe litery, cyfry, myślniki)',
    placementEmpty: 'Puste = niezadeklarowane',
    placementLevel: {
      chassis: 'Obudowa',
      rack: 'Rack',
      row: 'Rząd',
      pdu: 'PDU',
      pod: 'Pod',
      room: 'Pomieszczenie',
      datacenter: 'Datacenter',
      zone: 'Strefa',
      region: 'Region'
    },
    cablingTitle: 'Okablowanie',
    cablingSubtitle: 'Do którego portu switcha podłączony jest każdy interfejs — deklaracja żyje na węźle (Annex O.9)',
    cablingHint: 'Jeden kabel na NIC, jeden kabel na port w całej flocie (API odrzuca, wskazując właściciela). Okablowanie do portu będącego członkiem LAGG jest dozwolone — to przypadek bonda: przyszłe wyprowadzenie odda go jako LACP.',
    cablingInterface: 'Interfejs',
    cablingNotCabled: '— niepodłączony —',
    cablingNoInterfaces: 'Nie zaobserwowano żadnego interfejsu sieciowego',
    disksTitle: 'Dyski',
    disksSubtitle: 'Zaobserwowane urządzenia blokowe — jedno skanowanie na przebieg uzgadniania; tutaj zaznacza się dyski użyteczne jako OSD Ceph (N.15: kwalifikowalność jest jawna)',
    colDataDisk: 'Dysk danych',
    dataDisksHint: 'Zaznaczenie urządzenia deklaruje je jako użyteczne w roli OSD; numer seryjny jest jego pinem tożsamości — kopiowanym ze sprzętu, gdy dysk go zgłasza, albo wykuwanym (tvirt-…) w przeciwnym razie. Dialog rejestracji Ceph oferuje wyłącznie zadeklarowane dyski.',
    diskDeclaredSerial: 'zadeklarowany',
    diskNotObserved: 'zadeklarowany, ale nieobserwowany — należy podłączyć urządzenie ponownie albo odznaczyć',
    noDisks: 'Nie zaobserwowano jeszcze żadnego urządzenia blokowego',
    colSerial: 'Numer seryjny',
    colModel: 'Model',
    colSize: 'Rozmiar (GiB)',
    colDiskType: 'Typ',
    colInUse: 'W użyciu',
    colObservedAt: 'Zaobserwowano',
    diskInUse: 'w użyciu',
    diskFree: 'wolny',
    diskMounted: 'zamontowany',
    diskPartitions: 'partycje',
    passthroughTitle: 'Urządzenia passthrough',
    passthroughSubtitle: 'Zaobserwowane GPU i urządzenia USB — tutaj zaznacza się, co TVirt może przekazać maszynom wirtualnym; oznaczenie rejestruje tożsamość urządzenia (runda U1+G1)',
    passthroughHint: 'Oznaczenie rejestruje urządzenie (stabilny identyfikator — cel tagów i wymagań klasy). Oznaczona GPU ma CAŁĄ swoją grupę IOMMU związaną z vfio-pci w komplecie — natychmiast opuszcza hosta; zdjęcie oznaczenia przywraca natywny sterownik. Dla USB istnieją oba ratyfikowane modele: per urządzenie (vendor+produkt, gdziekolwiek jest wpięte) i per port fizyczny (do VM trafia cokolwiek, co w nim tkwi). USB nie wiąże się w chwili oznaczenia — podłączenie następuje w czasie działania VM.',
    passthroughGpusTitle: 'GPU / PCIe',
    passthroughUsbTitle: 'USB',
    colUsable: 'Użyteczne dla TVirt',
    colGpu: 'GPU',
    colPciAddress: 'Adres PCI',
    colDriver: 'Sterownik',
    colVerdict: 'Werdykt',
    gpuEligible: 'Kwalifikuje się',
    gpuIneligible: 'Nie kwalifikuje się',
    gpuReason: {
      'no-iommu': 'IOMMU nieaktywne na hoście',
      'group-spans-slots': 'grupa IOMMU nie jest odizolowana: rozciąga się na inne sloty',
      'multiple-display': 'grupa IOMMU nie jest odizolowana: więcej niż jedna funkcja graficzna',
      'foreign-function': 'grupa IOMMU nie jest odizolowana: zawiera obcą funkcję'
    },
    vfioNotReady: 'IOMMU nie jest aktywne na tym hoście: żadna GPU się nie kwalifikuje, dopóki platforma hosta go nie włączy (ISO OEM) — TVirt nigdy nie rusza kernel args w czasie działania.',
    vfioMissingKernelArg: 'IOMMU nie jest aktywne na tym hoście: firmware zgłasza VT-d/AMD-Vi (tablica ACPI DMAR/IVRS jest obecna), ale brakuje kernel arg — należy dodać intel_iommu=on (Intel) albo usunąć amd_iommu=off (AMD) z command line jądra i zrestartować. TVirt nigdy nie rusza kernel args w czasie działania.',
    vfioFirmwareDisabled: 'IOMMU nie jest aktywne na tym hoście: VT-d/AMD-Vi jest wyłączone w firmware (brak tablicy ACPI DMAR/IVRS) albo CPU tego nie obsługuje — należy włączyć je w konfiguracji firmware, żaden kernel arg tego nie uruchomi. TVirt nigdy nie rusza hosta w czasie działania.',
    gpuBindError: 'Bind vfio-pci nie powiódł się na {address}: {error}',
    firewallBridgesTitle: 'Firewall na niezarządzanych bridge',
    firewallBridgesSubtitle: 'Bridge zbudowane ręcznie na tym węźle, których setup zgadza się na chainy firewalla renderowane przez TVirt na podłączonych kartach NIC gości',
    firewallBridgesHint: 'TVirt nigdy nie dotyka obcego bridge — chain kotwiczy się na tap/veth, który zawsze jest własnością TVirt. Lista jest bramką zgody: default-deny i anti-spoofing potrafią zepsuć to, czego oczekuje ręczny setup, więc karta NIC z firewallem na niezarządzanym bridge NIE wymienionym tutaj zostaje odrzucona mówiącym błędem.',
    firewallBridgesEmpty: 'Żaden niezarządzany bridge nie zgadza się na chainy firewalla renderowane przez TVirt na tym węźle.',
    firewallBridgeAdd: 'Dodaj bridge',
    firewallBridgeInvalid: 'To nie jest nazwa interfejsu Linuksa (1-15 znaków, bez ukośnika i spacji)',
    firewallBridgeDuplicate: 'Nazwa już na liście',
    colMarkDevice: 'Per urządzenie',
    colMarkPort: 'Per port',
    usbHub: 'hub',
    colUsbId: 'Vendor:Product',
    colPort: 'Port',
    passthroughOrphan: 'osierocone — zarejestrowane, ale już niewykrywane: należy je podłączyć ponownie albo zdjąć oznaczenie',
    noGpus: 'Nie zaobserwowano jeszcze żadnej GPU',
    noUsb: 'Nie zaobserwowano jeszcze żadnego urządzenia USB',
    networkGeneration: 'Generacja sieci',
    applied: 'Zastosowana',
    converged: 'zgodny',
    behind: 'w tyle — {m} / {n}',
    notConfigured: 'nieskonfigurowane',
    rollbackBody: 'Zastosowanie generacji {gen} nie powiodło się: {error}',
    rolledBackChip: 'wykonano rollback',
    nicsTitle: 'NIC',
    nicsSubtitle:
      'Ewidencja zarządzanych kart NIC — rejestracja JEST deklaracją zarządzania: zarejestrowana NIC bez konfiguracji nie jest ruszana (clear-if deklaruje ją jawnie czystą), a urządzenie niezarejestrowane nie jest ruszane nigdy',
    addNic: 'Zarejestruj NIC',
    addNicTitle: 'Zarejestruj NIC (add-nic)',
    delNic: 'Zakończ zarządzanie',
    delNicTitle: 'Zakończ zarządzanie (del-nic)',
    delNicConfirm:
      'Zarządzanie {name} zostaje zakończone: wpis ewidencyjny i jego konfiguracja są usuwane, a profil TVirt zdejmowany — urządzenie zostaje w takim stanie, w jakim ma je Linux.',
    nicName: 'Nazwa urządzenia',
    nicMac: 'Trwały adres MAC',
    nicMacHint: 'trwały adres MAC sprzętu — stabilna tożsamość ustalona przez TVirt Server Installer',
    colObserved: 'Obserwowana',
    nicObserved: 'obserwowana',
    nicNotObserved: 'nieobserwowana',
    nicMacMismatch: 'Rozbieżny MAC — zaobserwowano {mac}',
    noNics: 'Brak zarejestrowanych kart NIC — należy zarejestrować urządzenie, aby zacząć nim zarządzać',
    noManagedDevices: 'Brak zarządzanych urządzeń — najpierw trzeba zarejestrować NIC, wszystko buduje się na ewidencji',
    inventoryTitle: 'Zaobserwowane urządzenia',
    inventorySubtitle: 'Aktualizowane przy każdym przebiegu uzgadniania przez workera węzła — walidacja sprawdza nazwy urządzeń na tym inwentarzu',
    colDevice: 'Urządzenie',
    colType: 'Typ',
    colMac: 'MAC',
    colLink: 'Link',
    colSpeed: 'Prędkość',
    colTopology: 'Topologia',
    colMtu: 'MTU',
    colAddresses: 'Adresy',
    linkUp: 'up',
    linkDown: 'down',
    lacpDegraded: 'LACP nie agreguje',
    noInventory: 'Jak dotąd nie zgłoszono żadnego urządzenia',
    interfacesTitle: 'Interfejsy',
    interfacesSubtitle:
      'Konfiguracja L3 zarejestrowanych kart NIC i zadeklarowanych urządzeń logicznych — set-if zastępuje cały blok, edit-if poprawia właściwości, clear-if go opróżnia (jawne czyszczenie)',
    colConfig: 'Pożądana konfiguracja',
    clean: 'czysta',
    setIf: 'Zmień adresację',
    setIfTitle: 'Zmień adresację (set-if)',
    editIf: 'Zmień właściwości',
    editIfTitle: 'Zmień właściwości (edit-if)',
    clearIf: 'Opróżnij konfigurację',
    clearIfTitle: 'Opróżnij konfigurację (clear-if)',
    clearIfConfirm: 'Konfiguracja interfejsu zostaje opróżniona. Czysty interfejs to warunek konieczny, aby podporządkować go jako członka bonda albo bridge, bądź użyć jako interfejsu nadrzędnego VLAN.',
    ip4Mode: 'Tryb IPv4',
    ip6Mode: 'Tryb IPv6',
    modeUnconfigured: 'Nieskonfigurowany',
    modeStatic: 'Statyczny',
    modeDhcp: 'DHCP',
    ip4Addresses: 'Adresy IPv4',
    ip6Addresses: 'Adresy IPv6',
    addressesHint: 'CIDR, rozdzielone przecinkami',
    gw4: 'Brama IPv4',
    gw6: 'Brama IPv6',
    dns: 'Serwery DNS',
    dnsHint: 'rozdzielone przecinkami — puste zeruje DNS (set-if zastępuje cały blok)',
    routes4: 'Trasy statyczne IPv4',
    routes6: 'Trasy statyczne IPv6',
    routeTo: 'Cel (CIDR)',
    routeVia: 'Przez',
    addRoute: 'Dodaj trasę',
    routesChip: 'trasy',
    mtu: 'MTU',
    mtuHint: 'puste = wartość domyślna sterownika',
    vlansTitle: 'VLAN',
    addVlan: 'Dodaj VLAN',
    addVlanTitle: 'Dodaj VLAN (add-vlan)',
    delVlanTitle: 'Usuń VLAN (del-vlan)',
    vlanParent: 'Interfejs nadrzędny',
    vlanId: 'ID VLAN',
    vlanPreview: 'Nazwa urządzenia',
    colParent: 'Nadrzędny',
    colVlanId: 'ID',
    noVlans: 'Nie zadeklarowano żadnego VLAN-u',
    bondsTitle: 'Bond',
    addBond: 'Dodaj bond',
    addBondTitle: 'Dodaj bond (add-bond)',
    editBondTitle: 'Edytuj bond',
    editBond: 'Zapisz bond',
    delBondTitle: 'Usuń bond (del-bond)',
    bondName: 'Nazwa bonda',
    members: 'Członkowie',
    membersHint: 'członkami muszą być czyste interfejsy (bez konfiguracji L3)',
    bondMode: 'Tryb',
    modeActiveBackup: 'active-backup',
    modeLacp: 'LACP (802.3ad)',
    miimon: 'miimon (ms)',
    primary: 'Członek podstawowy',
    rate: 'Rate LACP',
    hash: 'Polityka haszowania przy transmisji',
    colMembers: 'Członkowie',
    colMode: 'Tryb',
    noBonds: 'Nie zadeklarowano żadnego bonda',
    bridgesTitle: 'Bridge',
    addBridge: 'Dodaj bridge',
    addBridgeTitle: 'Dodaj bridge (add-bridge)',
    editBridgeTitle: 'Edytuj bridge',
    editBridge: 'Zapisz bridge',
    delBridgeTitle: 'Usuń bridge (del-bridge)',
    bridgeName: 'Nazwa bridge’a',
    stp: 'STP',
    stpOn: 'STP włączone',
    stpOff: 'STP wyłączone',
    colStp: 'STP',
    noBridges: 'Nie zadeklarowano żadnego bridge’a',
    hostnameTitle: 'Hostname',
    hostname: 'Hostname',
    setHostname: 'Ustaw hostname',
    setHostnameTitle: 'Ustaw hostname (set-hostname)',
    hostnameHint: 'Wyłącznie tożsamość OS — nazwa węzła w klastrze nie jest ruszana',
    notSet: 'nieustawiony',
    staticHostsTitle: 'Statyczne wpisy hostów',
    addStaticHost: 'Dodaj wpis',
    addStaticHostTitle: 'Dodaj statyczny wpis hosta',
    delStaticHostTitle: 'Usuń statyczny wpis hosta',
    hostIp: 'Adres IP',
    hostNames: 'Nazwy',
    hostNamesHint: 'rozdzielone przecinkiem lub spacją',
    colIp: 'IP',
    colNames: 'Nazwy',
    noStaticHosts: 'Brak statycznych wpisów hostów',
    delConfirm: 'Usunięcie {name} z dokumentu stanu pożądanego — worker węzła zbiega z checkpointem NetworkManagera i automatycznym rollbackiem.',
    remove: 'Usuń',
    opError: 'Operacja sieciowa została odrzucona'
  }
}
